import React from "react";
import { useApi } from "../hooks/useApi";

/**
 * Select tipologia di turno condivisa: legge il catalogo configurabile
 * (Impostazioni → Tipologie turno), MAI una lista di fasce hardcoded qui.
 * onChange riceve l'intero oggetto tipologia selezionata (o null), non solo
 * il codice: chi la usa (es. CoperturaPage) legge orainizio/orafine da lì
 * invece di lasciarli digitare liberamente.
 */
export default function TipologiaTurnoSelect({
  value,
  onChange,
  required = false,
  className = "border border-gray-300 rounded px-2 py-1.5 text-sm bg-white",
}) {
  const { data, loading } = useApi("/planning/turnitipo");
  const items = data?.items || [];

  return (
    <select
      value={value || ""}
      onChange={(e) => {
        const tipo = items.find((t) => t.codice === e.target.value) || null;
        onChange(tipo);
      }}
      required={required}
      disabled={loading}
      className={className}
    >
      <option value="">— Seleziona tipologia turno —</option>
      {items.length === 0 && !loading && (
        <option value="" disabled>
          Nessuna tipologia configurata (Impostazioni → Tipologie turno)
        </option>
      )}
      {items.map((t) => (
        <option key={t.codice} value={t.codice}>
          {t.nome} ({t.orainizio}–{t.orafine})
        </option>
      ))}
    </select>
  );
}
